export const META_DATA = {
  brandName: "elvent",
  slogan: "Deine Marke für Outdoor-Familienprodukte.",
  description:
    "Ob faltbare Bollerwagen, stylische Laufräder oder Scooter – bei elvent findest du hochwertige Begleiter für eure Abenteuer. Komfortabel, durchdacht & sofort einsatzbereit. ✓ Kostenloser Versand · ✓ Familienfreundlich · ✓ Innovative Designs → Jetzt entdecken",
  logo: "/assets/web-app-manifest-512x512.png",
  ogImage: "/assets/open-graph-1200x630.png",
  origin: "https://elvent.shop",
  socials: {
    instagram: "https://www.instagram.com/elvent.shop/",
    facebook: "https://www.facebook.com/elvent.shop/",
    youtube: "https://www.youtube.com/@elvent_shop",
    tiktok: "https://www.tiktok.com/@elvent.shop",
    whatsapp: "https://wa.me/+4974252099488",
  },
  emails: {
    support: "kontakt@elvent.de",
    legal: "info@elvent.de",
  },
  phone: "+49 (0) 7424 60205 80",
  address: {
    companyName: "elvent GmbH",
    street: "Robert-Bosch-Str. 8",
    postalCode: "78549",
    town: "Spaichingen",
    country: "Deutschland",
    countryCode: "DE",
  },
  vatId: "DE815828318",
} as const
